import {GenericList} from './GenericList';
import {Contract} from "../../models/Contract";

export class ContractList extends GenericList<Contract> {}
